// extracted by mini-css-extract-plugin
export default {"root":"SubmittedTable_root__QIMBc","rows":"SubmittedTable_rows__bRtq+","pagination":"SubmittedTable_pagination__+qpRa"};